<script setup>
import { onClickOutside } from '@vueuse/core'
import {v4 as uuidv4} from "uuid"
import {computed, reactive, ref} from "vue"
import {Vue3SlideUpDown} from "vue3-slide-up-down"

const props = defineProps({
    modelValue: {
        type: [Number, String, Boolean],
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    options: {
        type: Object,
        default: () => {
        }
    },
    validator: {
        type: Object,
        default: () => {
        }
    },
    error: {
        type: String,
        default: ''
    }
})

const id = computed(() => `input-${uuidv4()}`)

const model = defineModel()

const state = reactive({
    isFocused: false
})

const errorMessage = computed(() => {
    if (props.validator?.$errors.length) {
        return props.validator.$errors.map(
            error => error.$message
        ).join(', ')
    }

    return props.error
})

const isValidationErrorVisible = computed(() => !!(errorMessage.value))

const handleSelectValue = (value) => {
    model.value = value
    setTimeout(() => {
        state.isFocused = false
    }, 25)
    state.isFocused = false
}

const handleOptionsOpen = () => {
    state.isFocused = !state.isFocused
}

const select = ref(null)

onClickOutside(select, () => {
    if(state.isFocused) {
        state.isFocused = false
    }
})


</script>

<template>
    <div class="textInputComponentWrapper">
    <div
        @click="handleOptionsOpen"
        :class="{
            dropDownComponent: true,
            hasValue: !!model,
            focus: state.isFocused,
        }"
        ref="select"
    >
        <div class="divTextInputLabel" style="text-align: center;">{{ label }}</div>
        <div class="divBorderLine"></div>
        <div class="divDropDownArrow"></div>
        <div class="divDropDownValue" style="font-size: 20px; font-weight: 600; text-align: center;">
            {{ model }}
        </div>
        <div class="divDropDownBox">
            <div
                class="divDropDownItem"
                v-for="(value, key) in options"
                :key="`${id}-${key}`"
                @click="() => handleSelectValue(value)"
            >
                {{ value }}
            </div>
        </div>
    </div>
    <Vue3SlideUpDown v-model="isValidationErrorVisible">
        <div v-for="$error in validator.$errors" :key="$error" class="validationError">
            {{ $error.$message }}
        </div>
    </Vue3SlideUpDown>
    </div>
</template>

<style>
.textInputComponent.error .divTextInputLabel {
    color: red;
}

.textInputComponent.error .divBorderLine {
    background-color: red;
}
.textInputComponentWrapper .validationError {
    color: red;
    font-size: 11px;
}
</style>
